import type { ActionExecutor } from "../TriggerEngine.interfaces";

export const webhook: ActionExecutor = async (_radio, config) => {
  const url = config?.url;
  if (!url) return;

  await fetch(url, { method: "POST", mode: "no-cors" });
};
